import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowChevronSolidIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.92 6.6C23.76 6.24 23.4 6 23 6H1.00002C0.600025 6 0.240025 6.23 0.080025 6.6C-0.079975 6.96 -0.00997505 7.39 0.260025 7.68L11.26 19.68C11.45 19.89 11.72 20 12 20C12.28 20 12.55 19.88 12.74 19.68L23.74 7.68C24.01 7.39 24.08 6.96 23.92 6.6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowChevronSolidIcon.displayName = 'ArrowChevronSolidIcon';
